import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  printPortalWrapper: {
    display: 'none',
    '&:not(:empty)': {
      '& ~ $appContainer': {
        '@media print': {
          display: 'none',
        },
      },
      '@media print': {
        display: 'block',
      },
    },
  },
  // need an object for css reference above ('& ~ $appContainer)
  appContainer: {},
});
